// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var FeaturesV3 = require("../../../reason/featureFlipper/FeaturesV3.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var QueryParams = require("../../../reason/QueryParams.bs.js");
var Types__Time = require("../../../reason/common/types/Types__Time.bs.js");
var UserSession = require("../../../reason/common/UserSession/UserSession.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var Form__Helpers = require("../../../reason/common/Form/Form__Helpers.bs.js");
var PropertyWizardFormRelay = require("./PropertyWizardFormRelay.bs.js");

var config = Object.fromEntries([[
        "draftId",
        QueryParams.UseQueryParams.ParamConfigs.numberParam
      ]]);

var ParamsConfig = {
  config: config
};

var UseQueryParams = QueryParams.UseQueryParams.Make(ParamsConfig);

var QueryParams_use = UseQueryParams.use;

var QueryParams$1 = {
  ParamsConfig: ParamsConfig,
  UseQueryParams: UseQueryParams,
  use: QueryParams_use
};

function decodeTime(time) {
  var match = Core__Option.map(time, Types__Time.decode);
  if (match !== undefined && match.TAG === "Ok") {
    return Caml_option.some(match._0);
  }
  
}

function toValidationResult(valid) {
  if (valid !== undefined) {
    if (typeof valid === "object") {
      if (valid.NAME === "Error") {
        return {
                TAG: "Error",
                _0: valid.VAL
              };
      } else {
        return {
                TAG: "Ok",
                _0: "NoValue"
              };
      }
    } else if (valid === "Valid") {
      return {
              TAG: "Ok",
              _0: "Valid"
            };
    } else {
      return {
              TAG: "Ok",
              _0: "NoValue"
            };
    }
  } else {
    return {
            TAG: "Ok",
            _0: "NoValue"
          };
  }
}

function useFormControl(fieldUpdater, initialTouched, initialValue, valid) {
  var updateDraft = PropertyWizardFormRelay.useUpdateDraft();
  var match = React.useState(function () {
        return initialValue;
      });
  var setValue = match[1];
  var value = match[0];
  var match$1 = React.useState(function () {
        return initialTouched;
      });
  var setTouched = match$1[1];
  var touched = match$1[0];
  var match$2 = React.useState(function () {
        return false;
      });
  var setFocused = match$2[1];
  var match$3 = React.useState(function () {
        return valid === "Valid";
      });
  var setHasBeenValid = match$3[1];
  var hasBeenValid = match$3[0];
  var update = function (value) {
    updateDraft(function (current) {
          switch (fieldUpdater.TAG) {
            case "Draft" :
                return fieldUpdater._0(current, value);
            case "DraftProperty" :
                return {
                        chapterPreferenceMlsComingSoonActivated: current.chapterPreferenceMlsComingSoonActivated,
                        draftProperty: fieldUpdater._0(current.draftProperty, value),
                        message: current.message,
                        serverDraftId: current.serverDraftId,
                        status: current.status,
                        subject: current.subject,
                        timeZone: current.timeZone
                      };
            case "Showing" :
                var showingNum = fieldUpdater.showingNum;
                var showings = current.draftProperty.showings;
                var newrecord = Caml_obj.obj_dup(current.draftProperty);
                var targetShowing = showings[showingNum];
                var tmp;
                if (targetShowing !== undefined) {
                  var updatedShowing = fieldUpdater.updater(targetShowing, value);
                  var updatedShowingsList = showings.slice();
                  updatedShowingsList.splice(showingNum, 1, updatedShowing);
                  tmp = updatedShowingsList;
                } else {
                  tmp = showings;
                }
                newrecord.showings = tmp;
                return {
                        chapterPreferenceMlsComingSoonActivated: current.chapterPreferenceMlsComingSoonActivated,
                        draftProperty: newrecord,
                        message: current.message,
                        serverDraftId: current.serverDraftId,
                        status: current.status,
                        subject: current.subject,
                        timeZone: current.timeZone
                      };
            
          }
        });
  };
  React.useEffect((function () {
          if (!hasBeenValid && valid === "Valid") {
            setHasBeenValid(function (param) {
                  return true;
                });
          }
          
        }), [valid !== undefined ? (
            typeof valid === "object" ? "Error" : "Valid"
          ) : undefined]);
  var tmp;
  var exit = 0;
  if (hasBeenValid || touched) {
    exit = 1;
  } else {
    tmp = undefined;
  }
  if (exit === 1) {
    tmp = valid !== undefined ? (
        typeof valid === "object" ? "error" : "ok"
      ) : undefined;
  }
  return {
          value: value,
          valueAsString: value !== undefined ? String(Caml_option.valFromOption(value)) : "",
          onBlur: (function () {
              if (!touched) {
                setTouched(function (param) {
                      return true;
                    });
                update(value);
              }
              setFocused(function (param) {
                    return false;
                  });
            }),
          onFocus: (function () {
              setFocused(function (param) {
                    return true;
                  });
            }),
          onChange: (function (value) {
              setValue(function (param) {
                    return value;
                  });
              update(value);
            }),
          focused: match$2[0],
          valid: hasBeenValid || touched ? valid : undefined,
          status: tmp
        };
}

function allValid(validations) {
  if (validations.every(function (validation) {
          return validation !== undefined && typeof validation === "object" ? false : true;
        })) {
    return "Valid";
  } else {
    return "Invalid";
  }
}

function allSubStepsValid(validations) {
  if (validations.every(function (validation) {
          return validation !== "Invalid";
        })) {
    return "Valid";
  } else {
    return "Invalid";
  }
}

function optResultToDummyStringResult(optResult) {
  return Core__Option.map(optResult, (function (m) {
                if (typeof m === "object") {
                  return {
                          NAME: "Error",
                          VAL: ""
                        };
                } else {
                  return "Valid";
                }
              }));
}

var FormUtils = {
  decodeTime: decodeTime,
  noneIfEmpty: Form__Helpers.noneIfEmpty,
  toValidationResult: toValidationResult,
  FieldError: undefined,
  useFormControl: useFormControl,
  allValid: allValid,
  allSubStepsValid: allSubStepsValid,
  optResultToDummyStringResult: optResultToDummyStringResult
};

function useMlsStatusCheck() {
  var mlsStatusCheckFeatureEnabled = FeaturesV3.useFeatureFlipper("CheckPropertyStatusOnMLS") === "on";
  var chapterHasPreference = UserSession.useChapterPreference("MlsComingSoon");
  if (mlsStatusCheckFeatureEnabled && chapterHasPreference !== "OFF") {
    return true;
  } else {
    return false;
  }
}

exports.QueryParams = QueryParams$1;
exports.FormUtils = FormUtils;
exports.useMlsStatusCheck = useMlsStatusCheck;
/* config Not a pure module */
